import { Accept } from 'react-dropzone';

import custom from '@/assets/images/activities/custom.webp';
import diary from '@/assets/images/activities/diary.webp';
import exercise from '@/assets/images/activities/exercise.webp';
import questionnaire from '@/assets/images/activities/questionnaire.webp';
import training from '@/assets/images/activities/training.webp';
import { ActivityType } from '@/hooks/api/activities/types';
import { JOURNAL } from '@/hooks/api/journals/types';

export const SELECTED_INSTITUTION_COOKIE = 'selectedInstitution';
export const COLLAPSING_MENU_STATE_COOKIE = 'isMenuCollapsed';
export const EVENTFLOW_LEGEND_STATE_COOKIE = 'isEventflowLegendHidden';

export const AUTH_REDIRECT_IV = 'AUTH_REDIRECT_IV';
export const AUTH_REDIRECT_TAG = 'AUTH_REDIRECT_TAG';

export const ACTIVITY_IMAGES = {
  [ActivityType.DIARY]: diary,
  [ActivityType.EXERCISE]: exercise,
  [ActivityType.QUESTIONNAIRE]: questionnaire,
  [ActivityType.TRAINING]: training,
  [JOURNAL]: exercise,
  [ActivityType.CUSTOM_EXERCISE]: custom,
};

// STORAGE KEYS
export const ACTIVITY_CART = 'activityCart';
export const INSTITUTION_COLOR = 'institutionColor';
export const ACTIVITY_CREATOR_DATA_KEY = 'activityCreatorData';
export const CATALOGUE_FILTERS_PREFIX_KEY = 'catalogue_filters_';

export const ACTIVITIES_FILTER = {
  LANGUAGE: 'ACTIVITIES_FILTER_LANGUAGE',
};
export const ONE_MB = 1048576;

const IMAGE_MIME_MAP = {
  'image/jpeg': ['.jpeg', '.jpg'],
  'image/png': ['.png'],
  'image/jpg': ['.jpg'],
  'image/webp': ['.webp'],
};

export const ALLOWED_IMG_TYPES = Object.keys(IMAGE_MIME_MAP);

export const IMAGE_DROPZONE_ACCEPT: Accept = IMAGE_MIME_MAP;

export enum ImageModalWarningType {
  EXTENSION = 'EXTENSION',
  SIZE = 'SIZE',
}

export const KeyboardKey = {
  ArrowDown: 'ArrowDown',
  ArrowUp: 'ArrowUp',
  Enter: 'Enter',
} as const;

export const STATUS_YLAH_URL = 'https://status.ylah.ch/';
export const SUPPORT_EMAIL = 'support@ylah.ch';
